import { inject, Injectable } from '@angular/core';
import { DiagnosticsApi } from '../connectors/backend';

@Injectable({ providedIn: 'root' })
export class DiagnosticService {
  private readonly diagnosticApi = inject(DiagnosticsApi);

  version() {
    return this.diagnosticApi.getVersion();
  }
}
